export { ServicesCard } from "./ServicesCard"
export { ServicesDetailCard } from "./ServicesDetailCard"
